<template>
    <div>
        <div class="title-row">
            <div class="page-title">收银台</div>
            <div class="btn" @click="show = true">查询收款及提现</div>
        </div>
        
        <div class="overlay" v-if="show">
            <div class="content">
                <div class="close-btn" @click="show = false">
                    <img src="/assets/images/shop-helper-close.png">
                </div>
                <div class="left">
                    <div class="title">微信支付商户助手</div>
                    <div class="qrcode-box">
                        <div class="qrcode-title">微信支付管理员扫码进入操作</div>
                        
                        <div class="qrcode-img">
                            <img src="/assets/images/shop-helper-qrcode.png">
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="img-row">
                        <div class="img-item">
                            <img src="/assets/images/shop-helper-img1.png">
                        </div>
                        <div class="img-item">
                            <img src="/assets/images/shop-helper-img2.png">
                        </div>
                    </div>
                    <div class="img-title">
                        <span>*</span>
                        <span>操作参考图</span>
                    </div>
                </div>
            </div>
        </div>
        
        <table-filter-one :query="query" :hideMemberLevel="true" @change="getFirstList"></table-filter-one>
        
        <div>
            <div class="mb-4" v-if="showWarning">
                <a-alert message="你暂未开通服务商分账功能，请授权开通后使用" type="error"/>
            </div>
            <a-table
                class="stock-table"
                :columns="table.columns"
                :data-source="table.data"
                :loading="table.loading"
                :pagination="table.pagination"
                :rowKey="record => record.id || record.key"
                @change="tableChanged"
                bordered
            >
                <div slot="idx" slot-scope="val,item">
                    {{ (query.page - 1) * 20 + table.data.indexOf(item) + 1 }}
                </div>
                
                <div slot="time" slot-scope="time">
                    {{ formatTime(time) }}
                </div>
                
                <div slot="transaction_id" slot-scope="transactionId">
                    
                    <a-tooltip>
                        <template slot="title">
                            <div style="width: 150px">{{ transactionId }}</div>
                        </template>
                        {{ transactionId.substring(16, transactionId.length) }}
                    </a-tooltip>
                
                </div>
                
                <div slot="payer" slot-scope="val,item">
                    <router-link v-if="item.member" :to="`/ast/members/${item.member.id}`">
                        <div class="member-card">
                            <div><img :src="item.member.avatar" alt=""></div>
                            <span class="member-name">{{ item.member.mark_name || item.member.name }}</span>
                        </div>
                        <div class="member-id">{{ item.member.member_id }}</div>
                    </router-link>
                </div>
                
                <div slot="parent" slot-scope="val,item">
                    
                    <template v-if="item.parent">
                        
                        <router-link v-if="item.parent" :to="`/ast/members/${item.parent.id}`">
                            <div class="member-card">
                                <img :src="item.parent.avatar" alt="">
                                <span class="member-name">{{ item.parent.mark_name || item.parent.name }}</span>
                            </div>
                            <div class="member-id">{{ item.parent.member_id }}</div>
                        </router-link>
                    
                    </template>
                
                
                </div>
                
                <div slot="money" slot-scope="money">
                    ￥{{ money }}
                </div>
                
                <div slot="remark" slot-scope="remark">
                    <template v-if="remark.length > 10">
                        <a-tooltip>
                            <template slot="title">
                                <div style="width: 150px">{{ remark }}</div>
                            </template>
                            <div class="remark">{{ remark.substring(0, 10) }}...</div>
                        </a-tooltip>
                    </template>
                    
                    <template v-else>
                        <div class="remark">{{ remark }}</div>
                    </template>
                </div>
                
                <div slot="op" slot-scope="val,item">
                    <div v-if="item.refund_amount > 0">
                        已退款{{ item.refund_amount }}元
                    </div>
                    <template v-else>
                        
                        <div class="text-link cursor-pointer" @click="gotoSharing(item)">
                            
                            <div v-if="item.upload_status != 4 && item.upload_status != 0">
                                {{ getUploadStatusText(item) }}
                            </div>
                            <template v-else-if="item.sharing === 1 || item.sharing === 3 ">
                                <button class="btn mb-4">分账</button>
                            </template>
                            <template v-else>
                                完结
                                <div> {{ formatTime(item.updated_at) }}</div>
                            </template>
                        </div>
                        
                        <div v-if="item.sharing === 3">
                            <a-popover title="原因">
                                <template slot="content">
                                    {{ item.sharing_error }}
                                </template>
                                <span><small>分账失败,<a>查看原因</a></small></span>
                            </a-popover>
                        </div>
                        
                        <div v-if="item.sharing === 1">
                            
                            <share-count-down-one class="mt-4" type="two"
                                                  :time="item.auto_sharing_time"></share-count-down-one>
                        
                        </div>
                        
                        <div v-if="item.sharing === 3">
                            <share-count-down-one class="mt-4" type="two"
                                                  :time="item.auto_sharing_time"></share-count-down-one>
                        </div>
                    
                    </template>
                
                
                </div>
            </a-table>
            
            <div class="export">
                <export-btn title="订单列表.xlsx" url="/ast-cashier/orders-export" :query="query"></export-btn>
            </div>
        
        </div>
    </div>
</template>

<script>
import api from "../../../repo/api";
import moment from 'moment';
import ShareCountDownOne from "@/views/AST/Cashier/Com/ShareCountDownOne.vue";
import TableFilterOne from "@/views/AST/Components/TableFilterOne.vue";
import ExportBtn from "@/views/AST/Components/ExportBtn.vue";

export default {
    name: "GoodsSync",
    components: {ExportBtn, TableFilterOne, ShareCountDownOne},
    data() {
        
        return {
            table: {
                columns: [
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        align: 'center',
                    },
                    {
                        title: '时间',
                        dataIndex: 'created_at',
                        align: 'center',
                        scopedSlots: {customRender: 'time'},
                    },
                    {
                        title: '订单号',
                        dataIndex: 'transaction_id',
                        align: 'center',
                        scopedSlots: {customRender: 'transaction_id'},
                    },
                    {
                        title: '购买用户',
                        dataIndex: 'payer',
                        align: 'left',
                        width: '150px',
                        scopedSlots: {customRender: 'payer'},
                    },
                    {
                        title: '上级推荐',
                        dataIndex: 'shop_price',
                        align: 'left',
                        width: '150px',
                        scopedSlots: {customRender: 'parent'},
                    },
                    {
                        title: '付款金额',
                        dataIndex: 'pay_amount',
                        align: 'center',
                        scopedSlots: {customRender: 'money'},
                    },
                    {
                        title: '冻结天数',
                        dataIndex: 'unlock_day',
                        align: 'center',
                    },
                    {
                        title: '付款备注',
                        dataIndex: 'subject',
                        align: 'left',
                        scopedSlots: {customRender: 'remark'},
                    },
                    {
                        title: '操作',
                        dataIndex: 'op',
                        align: 'center',
                        scopedSlots: {customRender: 'op'},
                    }
                ],
                loading: false,
                data: [],
                pagination: {
                    defaultCurrent: 1,
                    current: 1,
                    defaultPageSize: 10,
                    total: 1,
                    pageSize: 20
                },
            },
            list: [],
            fileName: '',
            query: {
                page: 1
            },
            log: {},
            showWarning: false,
            show: false,
        }
    },
    mounted() {
        this.getFirstList()
        this.checkPayStatus()
    },
    methods: {
        getUploadStatusText(item) {
            let status = +(item.upload_status)
            
            if (status === 1) {
                return '待发货'
            }
            
            if (status === 2) {
                return '已发货'
            }
            
            if (status === 3) {
                return '已确认收货'
            }
            
            if (status === 4) {
                return '交易完成'
            }
            
            if (status === 5) {
                return '已退款'
            }
            
            if (status === 6) {
                return '待微信结算'
            }
            
            return ''
        },
        getFirstList() {
            this.query.page = 1
            this.getList()
        },
        checkPayStatus() {
            api.post('/ast-cashier/check-share-pay-status', (res) => {
                this.showWarning = (res.data.status <= 0)
            })
        },
        gotoSharing(item) {
            
            if (item.biz_type === 'alliance') {
                return this.$message.error('美学联盟订单请在小程序上查看');
            }
            
            let path = `/ast/shop/cashier/sharing/${item.id}`
            this.$router.push(path)
        },
        getList() {
            
            this.table.loading = true
            
            api.get('/ast-cashier/orders', this.query, (data) => {
                
                this.table.data = data.data.data
                this.table.pagination.current = data.data.current_page
                this.table.pagination.total = data.data.total
                this.table.pagination.pageSize = data.data.per_page
                
                this.table.loading = false
                
            })
        },
        formatTime(time) {
            return moment(time).format('yyyy-MM-DD HH:mm')
        },
        
        tableChanged(pagination) {
            this.query.page = pagination.current
            this.getList()
        }
    }
}
</script>

<style lang="less" scoped>
.mt16 {
    margin-top: 16px;
}

.title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 26px;
    
    .page-title {
        margin: 0;
    }
    
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .content {
        width: 1028px;
        height: 548px;
        background: linear-gradient(180deg, #FFFFFF 0%, #EBF2FD 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        
        .close-btn {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
            padding: 24px;
            
            img {
                width: 16px;
                height: 16px;
            }
        }
        
        .left {
            width: 347px;
            height: 388px;
            background: #FFFFFF;
            border-radius: 12px;
            border: 1px solid #D2DCF6;
            margin-right: 40px;
            
            .title {
                width: 100%;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                line-height: 52px;
                text-align: center;
                border-bottom: 1px solid #EEEEEE;
            }
            
            .qrcode-box {
                margin-top: 24px;
                
                .qrcode-title {
                    width: 100%;
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                    text-align: center;
                }
                
                .qrcode-img {
                    width: 100%;
                    height: 256px;
                    margin-top: 16px;
                    text-align: center;
                    
                    img {
                        width: 256px;
                        height: 256px;
                    }
                }
            }
        }
        
        .right {
            width: 513px;
            height: 388px;
            background: linear-gradient(180deg, #D1DBF6 0%, #E6E9F9 100%);
            border-radius: 12px;
            
            .img-row {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 40px;
                padding: 0 88px;
            }
            
            .img-item {
                width: 149px;
                height: 308px;
                
                img {
                    width: 149px;
                    height: 308px;
                }
            }
            
            .img-title {
                width: 100%;
                
                text-align: center;
                margin-top: 13px;
                
                span {
                    color: #FF0000;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 20px;
                    
                    &:nth-child(2) {
                        color: #333333;
                    }
                }
                
                
            }
        }
    }
}

.member-card {
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: row;
    
    img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
    }
    
    .member-name {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        overflow: hidden;
        height: 20px;
        flex: 1;
    }
}

.cj {
    color: #FBB03B;
}

.yc-only .member-name {
    color: #FBB03B;
}

.remark {
    width: 100px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
}

.member-id {
    height: 20px;
    text-align: center;
    background-color: #ddd;
    font-size: 12px;
    margin-top: 5px;
    color: white;
    position: relative;
    padding: 2px 2px 2px 10px;
    
    &:before {
        position: absolute;
        left: 5px;
        content: ' ID ';
    }
}

.export {
    position: relative;
    top: -50px;
    display: inline-block;
}
</style>